// Buyer offer intake page (templates/deals/offer_intake/).  The server renders every
// state; this file only handles the upload dropzone and small form conveniences.

function intakeForm(el) {
    return el && el.closest('[data-offer-draft-form]');
}

function fieldValue(form, name) {
    const control = form.elements[name];
    return control ? control.value : '';
}

function setFieldValue(form, name, value) {
    const control = form.elements[name];
    if (!control) return;
    if (control instanceof RadioNodeList) {
        Array.from(control).forEach(function (radio) { radio.checked = radio.value === value; });
    } else {
        control.value = value;
    }
}

// --- Upload dropzone: browse or drop PDFs, then submit the hx-post upload form ---

function uploadPdfs(form, files) {
    const input = form.querySelector('[data-offer-pdf-input]');
    if (!input || !files || !files.length) return;
    if (files !== input.files) {
        const transfer = new DataTransfer();
        Array.from(files).forEach(function (file) { transfer.items.add(file); });
        input.files = transfer.files;
    }
    const label = form.querySelector('.file-uploader-text');
    const icon = form.querySelector('.file-uploader-icon i');
    if (label) {
        label.dataset.idleText = label.textContent;
        label.textContent = 'Uploading ' + input.files.length + ' PDF' + (input.files.length > 1 ? 's' : '') + '…';
    }
    if (icon) {
        icon.dataset.idleClass = icon.className;
        icon.className = 'fa-solid fa-spinner fa-spin';
    }
    form.requestSubmit();
}

// Success and 422 swap the card back in; a 413 from nginx, a 500 or a dropped connection
// swap nothing, so put the dropzone back to idle here.
document.addEventListener('htmx:afterRequest', function (event) {
    const form = event.detail.elt;
    if (!form.matches || !form.matches('[data-offer-upload-form]') || !form.isConnected) return;
    const label = form.querySelector('.file-uploader-text');
    const icon = form.querySelector('.file-uploader-icon i');
    if (label && label.dataset.idleText) label.textContent = label.dataset.idleText;
    if (icon && icon.dataset.idleClass) icon.className = icon.dataset.idleClass;
    const input = form.querySelector('[data-offer-pdf-input]');
    if (input) input.value = '';
});

document.addEventListener('click', function (event) {
    const dropzone = event.target.closest('[data-offer-dropzone]');
    if (!dropzone || event.target.matches('[data-offer-pdf-input]')) return;
    dropzone.querySelector('[data-offer-pdf-input]').click();
});

document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-offer-pdf-input]')) return;
    uploadPdfs(event.target.closest('[data-offer-upload-form]'), event.target.files);
});

document.addEventListener('dragover', function (event) {
    const dropzone = event.target.closest('[data-offer-dropzone]');
    if (!dropzone) return;
    event.preventDefault();
    dropzone.classList.add('file-uploader-dropzone-active');
});

document.addEventListener('dragleave', function (event) {
    const dropzone = event.target.closest('[data-offer-dropzone]');
    if (dropzone && !dropzone.contains(event.relatedTarget)) {
        dropzone.classList.remove('file-uploader-dropzone-active');
    }
});

document.addEventListener('drop', function (event) {
    const dropzone = event.target.closest('[data-offer-dropzone]');
    if (!dropzone) return;
    event.preventDefault();
    dropzone.classList.remove('file-uploader-dropzone-active');
    uploadPdfs(dropzone.closest('[data-offer-upload-form]'), event.dataTransfer.files);
});

// --- Contract form: choice clears, warranty cost, checklist options ---

function syncForm(form) {
    if (!form) return;
    form.querySelectorAll('[data-offer-clear-choice]').forEach(function (button) {
        button.hidden = !fieldValue(form, button.dataset.offerClearChoice);
    });
    const costWrap = form.querySelector('[data-offer-warranty-cost]');
    if (costWrap) costWrap.hidden = !['buyer', 'seller'].includes(fieldValue(form, 'home_warranty_paid_by'));

    const collection = fieldValue(form, 'checklist_collection');
    const hasChecklist = Boolean(collection) && collection !== form.dataset.offerNoneChecklistId;
    const toggle = function (selector, hidden) {
        const el = form.querySelector(selector);
        if (el) el.hidden = hidden;
    };
    const createCards = form.querySelector('input[name="create_asana_ticket"]');
    toggle('[data-offer-checklist-options]', !hasChecklist);
    toggle('[data-offer-assigned-user]', fieldValue(form, 'checklist_assignment') !== 'user');
    toggle('[data-offer-delivery-options]', !createCards || !createCards.checked);
    toggle('[data-offer-future-date]', fieldValue(form, 'checklist_date_option') !== 'future');
}

document.addEventListener('click', function (event) {
    const clear = event.target.closest('[data-offer-clear-choice]');
    if (!clear) return;
    const form = intakeForm(clear);
    setFieldValue(form, clear.dataset.offerClearChoice, '');
    if (clear.dataset.offerClearChoice === 'home_warranty_paid_by') setFieldValue(form, 'home_warranty_cost', '');
    syncForm(form);
});

document.addEventListener('change', function (event) {
    const form = intakeForm(event.target);
    if (!form) return;
    if (event.target.name === 'home_warranty_paid_by') setFieldValue(form, 'home_warranty_cost', '');
    syncForm(form);
});

document.body.addEventListener('htmx:load', function (event) {
    event.target.querySelectorAll('[data-offer-draft-form]').forEach(syncForm);
});
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-offer-draft-form]').forEach(syncForm);
});

// --- Earnest money: "% of price" is an entry aid; the saved value is always dollars ---

// ``write`` is false when only the mode changed, so switching to percent never rounds the saved dollars.
function syncEarnestMoney(form, write) {
    const wrap = form && form.querySelector('[data-offer-emd]');
    if (!wrap) return;
    const percentMode = Boolean(wrap.querySelector('[data-offer-emd-mode][value="percent"]:checked'));
    const result = wrap.querySelector('[data-offer-emd-result]');
    wrap.querySelector('[data-offer-emd-amount]').hidden = percentMode;
    wrap.querySelector('[data-offer-emd-percent]').hidden = !percentMode;
    result.hidden = !percentMode;
    if (!percentMode) return;
    const price = Number(fieldValue(form, 'offer_price'));
    const percent = wrap.querySelector('[data-offer-emd-percent-input]').value;
    if (!price || percent === '') {
        result.textContent = price ? 'Enter the percent of the offer price.' : 'Enter the offer price first.';
        return;
    }
    const dollars = write ? (Math.round(price * Number(percent)) / 100).toFixed(2) : fieldValue(form, 'earnest_money');
    if (write) setFieldValue(form, 'earnest_money', dollars);
    const money = function (value) {
        return Number(value).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    };
    result.textContent = '= ' + money(dollars) + ' at the ' + money(price) + ' offer price.';
}

document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-offer-emd-mode]')) return;
    const form = intakeForm(event.target);
    const input = form.querySelector('[data-offer-emd-percent-input]');
    const price = Number(fieldValue(form, 'offer_price'));
    const dollars = Number(fieldValue(form, 'earnest_money'));
    if (event.target.value === 'percent') {
        input.value = price && dollars ? String(Math.round(dollars / price * 10000) / 100) : '';
    }
    syncEarnestMoney(form, false);
});

document.addEventListener('input', function (event) {
    if (event.target.matches('[data-offer-emd-percent-input], [name="offer_price"]')) {
        syncEarnestMoney(intakeForm(event.target), true);
    }
});

// --- CRM pickers: typing clears a stale pick; the title officer list follows the company ---

function refreshTitleOfficer(fieldName, companyId) {
    const block = document.querySelector('[data-offer-title-officer="' + fieldName + '"]');
    if (!block || !window.htmx) return;
    const url = new URL(block.dataset.officerUrl, window.location.href);
    if (companyId) url.searchParams.set('company', companyId);
    // No `source`: inside the contract form htmx drops a request sourced from the block.
    window.htmx.ajax('GET', url.pathname + url.search, {target: '#' + block.id, swap: 'outerHTML'});
}

document.addEventListener('input', function (event) {
    const input = event.target.closest(
        '[data-offer-agent-typeahead] .typeahead-input, [data-offer-title-typeahead] .typeahead-input'
    );
    if (!input) return;
    const host = input.closest('[data-offer-agent-typeahead], [data-offer-title-typeahead]');
    const targetName = host.dataset.typeaheadTarget;
    const selected = (host.closest('form') || host).querySelector('input[name="' + CSS.escape(targetName) + '"]');
    const isTitle = host.matches('[data-offer-title-typeahead]');
    const hadPick = Boolean(selected && selected.value);
    if (hadPick) selected.value = '';
    // SeeMe's typeahead clears the hidden input itself when the query drops under two
    // characters, before this handler runs; the officer list still belongs to the old company.
    if (isTitle && (hadPick || titleOfficerShown(targetName))) refreshTitleOfficer(targetName, '');
});

function titleOfficerShown(fieldName) {
    const block = document.querySelector('[data-offer-title-officer="' + fieldName + '"]');
    return Boolean(block && block.children.length);
}

document.addEventListener('typeahead:select', function (event) {
    const host = event.target.closest('[data-offer-title-typeahead]');
    if (host) refreshTitleOfficer(host.dataset.typeaheadTarget, event.detail && event.detail.id);
});

document.addEventListener('change', function (event) {
    const block = event.target.closest('[data-offer-title-officer]');
    const clear = block && block.querySelector('[data-offer-clear-officer]');
    if (clear && event.target.type === 'radio') clear.hidden = false;
});

document.addEventListener('click', function (event) {
    const clear = event.target.closest('[data-offer-clear-officer]');
    if (!clear) return;
    clear.closest('[data-offer-title-officer]').querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.checked = false;
    });
    clear.hidden = true;
});

// --- Party not in the CRM: the alert's Add opens the picker's prefilled inline create form ---
document.addEventListener('click', function (e) {
    const add = e.target.closest && e.target.closest('[data-offer-party-add]');
    if (add) {
        const picker = document.getElementById(add.getAttribute('data-offer-party-add'));
        const open = picker && picker.querySelector('[data-inline-create-add]');
        if (!open) return;
        open.click();
        add.closest('[data-offer-party-review]').hidden = true;
        return;
    }
    // Cancelling the create form brings the alert back.
    const cancel = e.target.closest && e.target.closest('[data-inline-create-cancel]');
    const group = cancel && cancel.closest('.form-group');
    const review = group && group.querySelector('[data-offer-party-review]');
    if (review) review.hidden = false;
});

// Choosing a record answers the alert; clearing the picker (empty id and name) brings it back.
document.addEventListener('typeahead:select', function (e) {
    const group = e.target.closest && e.target.closest('.form-group');
    const review = group && group.querySelector('[data-offer-party-review]');
    if (review) review.hidden = Boolean(e.detail.id || e.detail.name);
});
